import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "editable-select",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enableEditing && _ctx.enableEditing(...args)))
  }, [
    _createVNode(_component_q_select, {
      modelValue: _ctx.currentValue,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
        _ctx.updateCallback
      ],
      options: _ctx.processedOptions,
      dense: "",
      "lazy-rules": "",
      outlined: "",
      "emit-value": "",
      "map-options": "",
      readonly: !_ctx.editing,
      ref: "inputRef",
      onBlur: _ctx.confirmEdit,
      class: _normalizeClass([_ctx.editing ? 'editable-select__active' : 'editable-select__inactive', { 'editable-select__null': _ctx.isModelNullable }]),
      clearable: _ctx.clearable,
      "hide-dropdown-icon": false,
      "options-html": "",
      "use-input": _ctx.filterFn && true,
      onFilter: _ctx.filterFn
    }, null, 8, ["modelValue", "options", "readonly", "onBlur", "class", "clearable", "use-input", "onUpdate:modelValue", "onFilter"])
  ]))
}